import { useEffect, useState } from 'react';
import { getFirstName, getFullName } from '@habity/services';
import { FeaturebaseConfig, TODO } from '@habity/types';
import { isAdmin, isBroker, isBrokerOrAdmin } from '~/lib/roles';

export const useFeaturebase = () => {
  const [settings, setSettings] = useState<FeaturebaseConfig | null>(null);

  const init = (settings: FeaturebaseConfig) => {
    setSettings(settings);
  };

  useEffect(() => {
    if (!settings) return;

    const { appId, organization, defaultBoard, locale, user, userHash } =
      settings || {};

    const win = window as TODO;

    if (typeof win.Featurebase !== 'function') {
      win.Featurebase = function () {
        // eslint-disable-next-line prefer-rest-params
        (win.Featurebase.q = win.Featurebase.q || []).push(arguments);
      };
    }
    if (user && userHash && isBrokerOrAdmin(user)) {
      win.Featurebase(
        'identify',
        {
          // Each 'identify' call should include an "organization" property,
          // which is your Featurebase board's name before the ".featurebase.app".
          organization: 'erikolsson',
          locale: 'sv',

          // Required. Replace with your customers data.
          email: user.email,
          name: getFullName(user),
          id: user.id.toString(),
          userHash,

          // Optional
          ...(user.avatar_url ? { profilePicture: user.avatar_url } : {}),
        }
        // (err: TODO) => {
        //   // Callback function. Called when identify completed.
        //   if (err) {
        //     console.error(err);
        //   } else {
        //     console.log('Data sent successfully!');
        //   }
        // }
      );
      win.Featurebase('boot', {
        appId,
        theme: 'light',
        // placement: 'top',
        email: user.email, // optional
        defaultBoard,
        userHash,
        id: user.id.toString(),
        userId: user.id.toString(),
        ...(user.avatar_url ? { profilePicture: user.avatar_url } : {}),
        name: user ? getFirstName(user.first_name) : '',
        hideMessenger: true,
      });
      // Only initialize Featurebase widgets for brokers and admins
      win.Featurebase('initialize_changelog_widget', {
        organization, // Replace this with your featurebase organization name
        placement: 'right', // Choose between right, left, top, bottom placement (Optional if fullscreenPopup is enabled)
        theme: 'light', // Choose between dark or light theme
        fullscreenPopup: true, // Optional - Open a fullscreen announcement of the new feature to the user
        alwaysShow: true, // Optional - Always show the announcement to the user
        locale, // Change the language, view all available languages from https://help.featurebase.app/en/articles/8879098-using-featurebase-in-my-language
        usersName: user ? getFirstName(user.first_name) : '', // Optional - Show the users name in the welcome message for the fullscreen popup
      });

      win.Featurebase('initialize_feedback_widget', {
        organization,
        theme: 'light',
        placement: 'right', // optional - remove to hide the floating button
        email: user.email, // optional
        name: getFullName(user),
        id: user.id.toString(),
        userHash,
        ...(user.avatar_url ? { profilePicture: user.avatar_url } : {}),
        defaultBoard, // optional - preselect a board
        locale: 'en',
        metadata: {
          device_type: window.navigator.userAgent,
          page_url: window.location.href,
          page_path: window.location.pathname,
          page_title: document.title,
        },
      });
    }
  }, [settings]);

  return { init };
};
